import styled from "styled-components";

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 160px;
  background-color: #fff;
  border-bottom: 1px solid #e0e0e0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 960px) {
    padding: 20px 40px;
  }

  @media (max-width: 768px) {
    padding: 16px 20px;
  }
`;

export const Logo = styled.img`
  max-height: 80px;
  max-width: 100%;
  width: auto;
  object-fit: contain;

  @media (max-width: 768px) {
    max-height: 60px;
  }
`;
